import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { get } from 'lodash';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import validateRulesForm from './forms/validateRulesForm';
import onSubmitProductionForms from './forms/onSubmitProductionForms';
import { mapBoolToString, showFormError } from './data/utils';
import ButtonNavigation from '../app-faq-components/ButtonNavigation';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';

const RulesForm = ({
  error,
  handleSubmit,
  insuranceToggle,
  moveFurnitureToggle,
  disableButton,
  intl,
  ...props
}) => {
  const translationMessages = defineMessages({
    yes: {
      id: 'hosting.rules_form.yes',
      defaultMessage: 'Yes'
    },
    no: {
      id: 'hosting.rules_form.no',
      defaultMessage: 'No'
    }
  });
  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <h2><FormattedMessage id="hosting.rules_form.production_rules_heading" defaultMessage="Production Rules"/></h2>
      <p className="text-gray-600"><FormattedMessage id="hosting.rules_form.production_rules_text" defaultMessage="Let photo and video producers know what is and isn’t allowed in your space."/></p>
      <div className="questions-section">
        <h6><FormattedMessage id="hosting.rules_form.can_move_furniture_decorations_heading" defaultMessage="Can furniture or decorations be moved?"/></h6>
        <Field
          name='can_move_furniture'
          component={ToggleField}
          onChange={() => props.dispatch(
            change('PRODUCTION_RULES_FORM', 'furniture_move_description', ''))
          }
          attributes={{
            'data-testing-id': 'can_move_furniture'
          }}
          firstOption={
            {
              id: 'can_move_furniture_true',
              value: 'true',
              label: intl.formatMessage(translationMessages.yes)
            }}
          secondOption={
            {
              id: 'can_move_furniture_false',
              value: 'false',
              label: intl.formatMessage(translationMessages.no)
            }}
        />
        {
          moveFurnitureToggle &&
          <div className="margin-xl-top">
            <p className="heavy"><FormattedMessage id="hosting.rules_form.can_move_furniture_decorations_rules_description" defaultMessage="Describe your rules around moving furniture or decorations"/></p>
            <ul className="list-style-inside no-gutter text-gray-600 margin-lg-bottom">
              <li><FormattedMessage id="hosting.rules_form.can_move_furniture" defaultMessage="Can furniture be removed from the building?"/></li>
              <li><FormattedMessage id="hosting.rules_form.can_move_decorations" defaultMessage="Can wall decorations be removed?"/></li>
            </ul>
            <Field
              name='furniture_move_description'
              component={TextAreaField}
              attributes={{
                'data-testing-id': 'furniture_move_description'
              }}
              maxLength={1000}
            />
          </div>
        }
      </div>
      <div className="questions-section">
        <h6><FormattedMessage id="hosting.rules_form.smoke_machine_usage" defaultMessage="Can smoke machines be used?"/></h6>
        <Field
          name='can_use_smoke_machines'
          component={ToggleField}
          attributes={{
            'data-testing-id': 'can_use_smoke_machines'
          }}
          firstOption={
            {
              id: 'can_use_smoke_machines_true',
              value: 'true',
              label: intl.formatMessage(translationMessages.yes)
            }}
          secondOption={
            {
              id: 'can_use_smoke_machines_false',
              value: 'false',
              label: intl.formatMessage(translationMessages.no)
            }}
        />
      </div>
      <div className="questions-section">
        <h6><FormattedMessage id="hosting.rules_form.nudity_allowed" defaultMessage="Do you allow nudity?"/></h6>
        <Field
          name='nudity_allowed'
          component={ToggleField}
          attributes={{
            'data-testing-id': 'nudity_allowed'
          }}
          firstOption={
            {
              id: 'nudity_allowed_true',
              value: 'true',
              label: intl.formatMessage(translationMessages.yes)
            }}
          secondOption={
            {
              id: 'nudity_allowed_false',
              value: 'false',
              label: intl.formatMessage(translationMessages.no)
            }}
        />
      </div>
      <hr className="space-type-line-break"/>
      <div className="text-danger text-small margin-xl-bottom">{error}</div>
      <ButtonNavigation
        {...props}
        submitCtaText={
          <FormattedMessage
            id="hosting.button_navigation.button_text_submit"
            defaultMessage="Submit"
          />
        } />
    </form>
  );
};

RulesForm.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  error: PropTypes.string,
  insuranceToggle: PropTypes.bool,
  moveFurnitureToggle: PropTypes.bool,
  spaceId: PropTypes.string,
  intl: intlShape
};

const config = {
  form: 'PRODUCTION_RULES_FORM',
  onSubmit: onSubmitProductionForms,
  validate: validateRulesForm,
  onSubmitFail: showFormError
};

const selector = formValueSelector('PRODUCTION_RULES_FORM');

function mapStateToProps (state) {
  const insuranceToggle = selector(state, 'requires_production_insurance');
  const moveFurnitureToggle = selector(state, 'can_move_furniture');
  const productionDetails = get(state, 'space.data.production_details', {});

  return {
    insuranceToggle: 'true' === insuranceToggle,
    moveFurnitureToggle: 'true' === moveFurnitureToggle,
    initialValues: {
      ...mapBoolToString(productionDetails)
    }
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(RulesForm)));
